import styled from 'styled-components';

export const MissionSection = styled.section`
  width: min(100%, 1480px);
  margin: var(--space-xxxxl) auto;
  padding: var(--space-xxxl) var(--space-xxxxl);
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: var(--space-xxxl);

  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-xxl);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) var(--space-m);
    margin: var(--space-xxxl) auto;
    gap: var(--space-xl);
  }
`;

export const MissionText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h2 {
    margin: var(--space-xs) 0 var(--space-l) 0;

    color: var(--grey7);

    font-size: clamp(2.2rem, 4vw, 3.6rem);
    line-height: 1;
    font-weight: 900;

    letter-spacing: -0.04em;
  }

  p:not(.eyebrowHeader) {
    max-width: 680px;

    margin: 0 0 var(--space-m) 0;

    color: var(--grey5);

    line-height: 1.85;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const MissionValues = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const MissionValueCard = styled.div`
  padding: var(--space-l);

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(249, 250, 251, 0.96) 100%
  );

  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 20px;

  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.05);

  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  span {
    display: inline-flex;

    margin-bottom: var(--space-s);

    color: var(--orange5);

    font-size: 0.8rem;
    font-weight: 900;

    letter-spacing: 0.12em;
  }

  h3 {
    margin: 0 0 var(--space-xs) 0;

    color: var(--grey7);

    font-size: 1.05rem;
    line-height: 1.3;
    font-weight: 850;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.92rem;
    line-height: 1.7;
    font-weight: 500;
  }

  &:hover {
    transform: translateY(-2px);

    border-color: rgba(230, 139, 7, 0.16);

    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  }
`;
